import {Icon, IconName} from '@wandb/weave/components/Icon';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useLocalStorage} from '../useLocalStorage';

export const InfoBanner: React.FC<{
  hintKey: string;
  icon: IconName;
  bannerContent: string;
}> = ({hintKey, icon, bannerContent}) => {
  const [isHidden, setIsHidden] = useLocalStorage<boolean>(
    `hint.${hintKey}`,
    false
  );

  if (isHidden) {
    return null;
  }

  return (
    <TailwindContents>
      <div className="flex items-center justify-between bg-blue-200 rounded-lg text-blue-650 py-12 px-16 mb-16 text-base leading-5 font-normal">
        <div className="flex items-center gap-12 flex-1">
          <Icon name={icon} className="flex-shrink-0" />
          <div className="text-base font-normal leading-snug">
            {bannerContent}
          </div>
        </div>
        <button
          onClick={() => setIsHidden(true)}
          aria-label="Dismiss banner"
          className="bg-transparent border-none cursor-pointer p-4 flex items-center justify-center flex-shrink-0 hover:opacity-70"
          type="button">
          <Icon name="close" />
        </button>
      </div>
    </TailwindContents>
  );
};
